export default {
    A1: {
        t: 's',
        v: '#',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    B1: {
        t: 's',
        v: '類型',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    C1: {
        t: 's',
        v: '動撥日期',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    D1: {
        t: 's',
        v: '動撥金額',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    E1: {
        t: 's',
        v: '信保費',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    F1: {
        t: 's',
        v: '手續費',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    G1: {
        t: 's',
        v: '已還款金額',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    H1: {
        t: 's',
        v: '還款進度',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    I1: {
        t: 's',
        v: '存入銀行帳戶',
        s: {
            fill: { fgColor: { rgb: 'fff3cc' } },
        },
    },
    '!ref': 'A1:I1',
};
